import list_icon from '@/assets/img/device/nd68/icon.png'
import { Mars68 } from './mars68'
import { EffectIndex } from '@/define/define'
import { LightEffectModeType } from '@/define/light'

export class Mars68SE extends Mars68 {
  name: string = 'Mars68SE'
  icon: string = list_icon
  width: number = 640

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {}
}
